import { createContext, useContext } from 'react'

export type DialogState = { mode: 'closed' } | { mode: 'insert' } | { mode: 'update'; itemId: string }

type StructuredObservationListContextValue = {
  dialog: DialogState
  openInsert: () => void
  openUpdate: (id: string) => void
  closeDialog: () => void
}

export const StructuredObservationListContext = createContext<StructuredObservationListContextValue | null>(null)

export const useStructuredObservationDialog = () => {
  const context = useContext(StructuredObservationListContext)
  if (!context) {
    throw new Error('useStructuredObservationDialog must be used within a StructuredObservationList')
  }
  return context
}
